import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {ServiceDomainGetSchema} from '../../../../api/DBSchema/ServiceDomain';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';

const pageSchema = ServiceDomainGetSchema.pages.notifications;
const pageId = pageSchema.pageId;

function ServiceDomainNotifications({
    serviceDomainObject,
    setServiceDomainData
}) {
    const { t } = useTranslation();

    const pageData = serviceDomainObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setServiceDomainData([pageId, paramName], value);
    }, [setServiceDomainData]);

    const isEnableMonitor = pageData[pageSchema.isEnableMonitor];

    return (
        <EditorLayout>
            <SMCCheckbox
                label={t('SMP.SYSTEM.SERVICE_DOMAINS.NOTIFICATIONS.NOTIGY_LINE1')}
                checked={isEnableMonitor}
                onChange={e => setPageValue(pageSchema.isEnableMonitor, e.target.checked)}
            />
        </EditorLayout>
    )
}

export default ServiceDomainNotifications;